<script>
  import { Navigate } from "svelte-router-spa";
</script>

<div class="menu absolute w-screen h-screen bg-gray-900 z-50 text-white">
  <div
    class="menu-list w-screen h-screen flex justify-center	flex-col items-center"
  >
    <Navigate to="/"><a>Home</a></Navigate>
    <Navigate to="imprint"><a>Mint Gallery</a></Navigate>
    <Navigate to="imprint"><a>What is this?</a></Navigate>
    <Navigate to="imprint"><a>Imprint</a></Navigate>
  </div>
</div>

<style>
  .menu-list {
    font-size: 2.5rem;
    font-weight: 900;
  }
</style>
